import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/AchieversPark"; // Check if path is correct relative to this file

// Import images for overlays
import pri from "../assets/achievers/pri.png";
import sec from "../assets/achievers/sec.png";
import tarmac from "../assets/achievers/tarmac.png";
import centre from "../assets/achievers/trading centre.PNG"; // Check extension case

const AchieversPark = () => {
  const projectId = "PRJ00058";
  const title = "Achievers Business Park -Kimuka";

  const mapConfig = {
    minZoom: 5,
    zoom: 6.5,
    // We can let the component calculate center, or pass it if we want exact match to previous
    // Previous code calculated it dynamically. Let's let SharedMapComponent do it.
    bounds: [
      [41.2, -185.22],
      [13.01, -163.07],
    ],
    imageOverlays: [
      {
        imageUrl: pri,
        imageBounds: [
          [33.74, -183.1],
          [32.47, -180.7],
        ],
      },
      {
        imageUrl: sec,
        imageBounds: [
          [40.94, -172.79],
          [39.92, -170.59],
        ],
      },
      {
        imageUrl: tarmac,
        imageBounds: [
          [39.38, -173.6],
          [39.07, -169.34],
        ],
      },
      {
        imageUrl: centre,
        imageBounds: [
          [38.97, -183.75],
          [35.02, -175.89],
        ],
      },
    ],
    styleConfig: {
      mode: "plot_status",
      sizeField: "plot_size",
    },
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/achievers-business-park-kimuka/"
      fillOfferLink="https://forms.gle/hxLRYUAPwsV296nt7"
    />
  );
};

export default AchieversPark;
